var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 "},[_c('div',{staticClass:"max-w-3xl mx-auto"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }